import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { BaseService } from '../../services/base.service';
import { NotificationsService, ToastMessage } from '../../services/notification.service';

@Component({
  selector: 'ara-notifications',
  template: `
    <p-toast position="top-left" baseZIndex="5000" life="3000" (onClose)="closePopup($event)"></p-toast>
  `,
})
export class NotificationsComponent implements OnInit, OnDestroy {
  growl: ToastMessage[] = [];
  growlSubscription: Subscription;
  isSticky: boolean = false;
  constructor(
    private notificationsService: NotificationsService,
    private baseService: BaseService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.subscribeToGrowlNotifications();
  }

  subscribeToGrowlNotifications() {
    this.growlSubscription = this.notificationsService.growlNotificationChange
      .subscribe(notification => {
        this.messageService.add(notification);
        if (notification['sticky']) {
          this.isSticky = true;
        } else {
          setTimeout(() => {
            this.growl.splice(this.growl.indexOf(notification), 1);
          }, 3000);
        }
      });
  }

  refresh() {
    if (this.isSticky) {
      Object.keys(localStorage).filter(key => key.indexOf('Filter') > -1).forEach(key => localStorage[key] = null);
      this.baseService.setItemInSession('appVersion', this.baseService.getItemFromSession('latestAppVersion'));
      this.baseService.setItemInSession('latestAppVersion', null);
      window.location.href = window.location.href;
      document.dispatchEvent(
        new KeyboardEvent("keydown", {
          key: "r",
          code: "KeyR",
          shiftKey: true,
          ctrlKey: true
        })
      );
      window.location.reload();
    }
  }

  closePopup(message: any) {
    if (message && message.message.sticky) {
      this.notificationsService.toastNotify("error", "Error Message", "You are using older version of application. Please press CTRL+SHIFT+R to get latest update.", true);
      this.refresh();
    }
  }
  ngOnDestroy() {
    this.growlSubscription.unsubscribe();
  }
}
